import { createRequestTypes, action } from "../../utils/reducer";

export const CREATE_APPLICATION = createRequestTypes("CREATE_APPLICATION");
export const createApplication = {
  request: (data) => action(CREATE_APPLICATION.REQUEST, data),
  success: (data) => action(CREATE_APPLICATION.SUCCESS, data),
  failure: (error) => action(CREATE_APPLICATION.FAILURE, error),
};
export const RESET_CREATE_APPLICATION = createRequestTypes("RESET_CREATE_APPLICATION");
export const resetCreateApplication = {
  success: () => action(RESET_CREATE_APPLICATION.SUCCESS)
};


export const FETCH_APPLICATION = createRequestTypes("FETCH_APPLICATION");
export const fetchApplication = {
  request: (data) => action(FETCH_APPLICATION.REQUEST, data),
  success: (data) => action(FETCH_APPLICATION.SUCCESS, data),
  failure: (error) => action(FETCH_APPLICATION.FAILURE, error),
};
export const RESET_FETCH_APPLICATION = createRequestTypes("RESET_FETCH_APPLICATION");
export const resetFetchApplication = {
  success: () => action(RESET_FETCH_APPLICATION.SUCCESS)
};

export const UPDATE_PERSONAL_DETIALS = createRequestTypes("UPDATE_PERSONAL_DETIALS");
export const updatePersonalDetails = {
  request: (data) => action(UPDATE_PERSONAL_DETIALS.REQUEST, data),
  success: (data) => action(UPDATE_PERSONAL_DETIALS.SUCCESS, data),
  failure: (error) => action(UPDATE_PERSONAL_DETIALS.FAILURE, error),
};

export const RESET_UPDATE_PERSONAL_DETIALS = createRequestTypes("RESET_UPDATE_PERSONAL_DETIALS");
export const resetUpdatePersonalDetails = {
  success: () => action(RESET_UPDATE_PERSONAL_DETIALS.SUCCESS)
};

export const UPDATE_COURSE = createRequestTypes("UPDATE_COURSE");
export const updateCourse = {
  request: (data) => action(UPDATE_COURSE.REQUEST, data),
  success: (data) => action(UPDATE_COURSE.SUCCESS, data),
  failure: (error) => action(UPDATE_COURSE.FAILURE, error),
};

export const RESET_UPDATE_COURSE = createRequestTypes("RESET_UPDATE_COURSE");
export const resetUpdateCourse = {
  success: () => action(RESET_UPDATE_COURSE.SUCCESS)
};


export const UPDATE_QUALIFICATION = createRequestTypes("UPDATE_QUALIFICATION");
export const updateQualification = {
  request: (data) => action(UPDATE_QUALIFICATION.REQUEST, data),
  success: (data) => action(UPDATE_QUALIFICATION.SUCCESS, data),
  failure: (error) => action(UPDATE_QUALIFICATION.FAILURE, error),
};

export const RESET_UPDATE_QUALIFICATION = createRequestTypes("RESET_UPDATE_QUALIFICATION");
export const resetUpdateQualification = {
  success: () => action(RESET_UPDATE_QUALIFICATION.SUCCESS)
};

export const UPDATE_EVIDENCE = createRequestTypes("UPDATE_EVIDENCE");
export const updateEvidence = {
  request: (data) => action(UPDATE_EVIDENCE.REQUEST, data),
  success: (data) => action(UPDATE_EVIDENCE.SUCCESS, data),
  failure: (error) => action(UPDATE_EVIDENCE.FAILURE, error),
};

export const UPDATE_FURTHER_DETAILS = createRequestTypes("UPDATE_FURTHER_DETAILS");
export const updateFurtherDetails = {
  request: (data) => action(UPDATE_FURTHER_DETAILS.REQUEST, data),
  success: (data) => action(UPDATE_FURTHER_DETAILS.SUCCESS, data),
  failure: (error) => action(UPDATE_FURTHER_DETAILS.FAILURE, error),
};

export const RESET_UPDATE_FURTHER_DETAILS = createRequestTypes("RESET_UPDATE_FURTHER_DETAILS");
export const resetUpdateFurtherDetails = {
  success: () => action(RESET_UPDATE_FURTHER_DETAILS.SUCCESS)
};

export const SUBMIT_APPLICATION = createRequestTypes("SUBMIT_APPLICATION");
export const submitApplication = {
  request: (data) => action(SUBMIT_APPLICATION.REQUEST, data),
  success: (data) => action(SUBMIT_APPLICATION.SUCCESS, data),
  failure: (error) => action(SUBMIT_APPLICATION.FAILURE, error),
};
export const RESET_SUBMIT_APPLICATION = createRequestTypes("RESET_SUBMIT_APPLICATION");
export const resetSubmitApplication = {
  success: () => action(RESET_SUBMIT_APPLICATION.SUCCESS)
};

export const SUBMIT_CONSENT = createRequestTypes("SUBMIT_CONSENT");
export const submitConsent = {
  request: (data) => action(SUBMIT_CONSENT.REQUEST, data),
  success: (data) => action(SUBMIT_CONSENT.SUCCESS, data),
  failure: (error) => action(SUBMIT_CONSENT.FAILURE, error),
};


export const FETCH_PERSONAL_DETIALS = createRequestTypes("FETCH_PERSONAL_DETIALS");
export const fetchPersonalDetails = {
  request: (data) => action(FETCH_PERSONAL_DETIALS.REQUEST, data),
  success: (data) => action(FETCH_PERSONAL_DETIALS.SUCCESS, data),
  failure: (error) => action(FETCH_PERSONAL_DETIALS.FAILURE, error),
};
export const UPDATE_FETCH_PERSONAL_DETIALS = createRequestTypes("UPDATE_FETCH_PERSONAL_DETIALS");
export const updateFetchPersonalDetails = {
  success: (data) => action(UPDATE_FETCH_PERSONAL_DETIALS.SUCCESS, data)
};



export const FETCH_ALL_COURSES = createRequestTypes("FETCH_ALL_COURSES");
export const fetchAllCourses = {
  request: (data) => action(FETCH_ALL_COURSES.REQUEST, data),
  success: (data) => action(FETCH_ALL_COURSES.SUCCESS, data),
  failure: (error) => action(FETCH_ALL_COURSES.FAILURE, error),
};

export const FETCH_STUDENT_COURSE = createRequestTypes("FETCH_STUDENT_COURSE");
export const fetchStudentCourse = {
  request: (data) => action(FETCH_STUDENT_COURSE.REQUEST, data),
  success: (data) => action(FETCH_STUDENT_COURSE.SUCCESS, data),
  failure: (error) => action(FETCH_STUDENT_COURSE.FAILURE, error),
};
export const UPDATE_FETCH_STUDENT_COURSE = createRequestTypes("UPDATE_FETCH_STUDENT_COURSE");
export const updateFetchStudentCourse = {
  success: (data) => action(UPDATE_FETCH_STUDENT_COURSE.SUCCESS, data)
};

export const FETCH_QUALIFICATION = createRequestTypes("FETCH_QUALIFICATION");
export const fetchQualification = {
  request: (data) => action(FETCH_QUALIFICATION.REQUEST, data),
  success: (data) => action(FETCH_QUALIFICATION.SUCCESS, data),
  failure: (error) => action(FETCH_QUALIFICATION.FAILURE, error),
};
export const UPDATE_FETCH_QUALIFICATION = createRequestTypes("UPDATE_FETCH_QUALIFICATION");
export const updateFetchQualification = {
  success: (data) => action(UPDATE_FETCH_QUALIFICATION.SUCCESS, data)
};


export const FETCH_FURTHER_DETAILS = createRequestTypes("FETCH_FURTHER_DETAILS");
export const fetchFurtherDetails = {
  request: (data) => action(FETCH_FURTHER_DETAILS.REQUEST, data),
  success: (data) => action(FETCH_FURTHER_DETAILS.SUCCESS, data),
  failure: (error) => action(FETCH_FURTHER_DETAILS.FAILURE, error),
};
export const UPDATE_FETCH_FURTHER_DETIALS = createRequestTypes("UPDATE_FETCH_FURTHER_DETIALS");
export const updateFetchFurtherDetails = {
  success: (data) => action(UPDATE_FETCH_FURTHER_DETIALS.SUCCESS, data)
};

export const GET_SHAREPOINT_FILES = "GET_SHAREPOINT_FILES";
export const getSharepointFiles = (data) => action(GET_SHAREPOINT_FILES, data);



export const DELETE_COURSE = createRequestTypes("DELETE_COURSE");
export const deleteCourse = {
  request: (data) => action(DELETE_COURSE.REQUEST, data),
  success: (data) => action(DELETE_COURSE.SUCCESS, data),
  failure: (error) => action(DELETE_COURSE.FAILURE, error),
};

export const DELETE_QUALIFICATION = createRequestTypes("DELETE_QUALIFICATION");
export const deleteQualification = {
  request: (data) => action(DELETE_QUALIFICATION.REQUEST, data),
  success: (data) => action(DELETE_QUALIFICATION.SUCCESS, data),
  failure: (error) => action(DELETE_QUALIFICATION.FAILURE, error),
};

export const GET_STUDENTID = createRequestTypes("GET_STUDENTID");
export const getStudentId = {
  request: (data) => action(GET_STUDENTID.REQUEST, data),
  success: (data) => action(GET_STUDENTID.SUCCESS, data),
  failure: (error) => action(GET_STUDENTID.FAILURE, error),
};